import { createContext, useContext, useState, useCallback, useMemo } from "react";
import PropTypes from "prop-types";

const LoadingContext = createContext();

export const LoadingProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);

  const showLoading = useCallback(() => setLoading(true), []);
  const hideLoading = useCallback(() => setLoading(false), []);

  const value = useMemo(
    () => ({ loading, showLoading, hideLoading }),
    [loading, showLoading, hideLoading],
  );

  return (
    <LoadingContext.Provider value={value}>
      {children}
    </LoadingContext.Provider>
  );
};

LoadingProvider.propTypes = {
  children: PropTypes.node,
};

export const useLoading = () => useContext(LoadingContext);
